import { render, staticRenderFns } from "./BundlesTemplate.vue?vue&type=template&id=9f3d090a&"
import script from "./BundlesTemplate.vue?vue&type=script&lang=js&"
export * from "./BundlesTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports